import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import i18n from "./i18n";
import VueMeta from "vue-meta";
import * as firebase from "firebase";
import appErrorSnackbar from "@/components/common/ErrorSnackbar.vue";
import appSuccessSnackbar from "@/components/common/SuccessSnackbar.vue";
import appLoadingOverlay from "@/components/common/LoadingOverlay.vue";
import DateFilter from "@/filters/dateFilter";
import FileSizeFilter from "@/filters/fileSizeFilter";
import GlobalMixin from "@/mixins/globalMixin.js"

Vue.config.productionTip = false;

Vue.component("app-error-snackbar", appErrorSnackbar);
Vue.component("app-success-snackbar", appSuccessSnackbar);
Vue.component("app-loading-overlay", appLoadingOverlay);
Vue.filter("dateFilter", DateFilter);
Vue.filter("fileSizeFilter", FileSizeFilter);
Vue.mixin(GlobalMixin);
Vue.use(VueMeta);

export const eventBus = new Vue();

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
  created() {
    firebase.initializeApp({
      apiKey: "AIzaSyA1gWkOE93De85BfVI8CnhC1V1hqsNivlA",
      authDomain: "newecohelp.firebaseapp.com",
      databaseURL: "https://newecohelp.firebaseio.com",
      projectId: "newecohelp",
      storageBucket: "newecohelp.appspot.com",
      messagingSenderId: "739812916123",
      appId: "1:739812916123:web:71c997f26bd7f6b0f2bf3e",
      measurementId: "G-L02XCW9PQX",
    });

    firebase.analytics();

    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        this.$store.dispatch("autoSignIn", user);
      }
    });
  },
}).$mount("#app");
